import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "jds_pin",
  "use": "jds_pin-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"jds_pin\">\n  <path fill-rule=\"evenodd\" d=\"M12 4a7 7 0 0 0-4.95 11.95l4.244 4.242a1 1 0 0 0 1.413 0l4.243-4.242A7 7 0 0 0 12 4Zm-5-.483a9 9 0 0 1 11.364 13.847l-4.243 4.243a3.001 3.001 0 0 1-4.24 0l-4.245-4.243A9 9 0 0 1 7 3.517Zm2.172 4.655a4 4 0 1 1 5.656 5.656 4 4 0 0 1-5.656-5.656ZM12 9a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z\" clip-rule=\"evenodd\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol